import type { JSX } from 'react';
import { cx } from '../cx';
import styles from './Spinner.module.css';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  /** Accessible label. Defaults to "Loading" — pass a more specific one when the surrounding context isn't obvious from a nearby heading. */
  label?: string;
  className?: string;
}

export function Spinner({ size = 'md', label = 'Loading', className }: SpinnerProps): JSX.Element {
  return (
    <span
      className={cx(styles.spinner, styles[size], className)}
      role="status"
      aria-label={label}
    />
  );
}
